import DangerousWithSanitization from '@base/DangerousWithSanitization';
import { QUESTION_NAV_INSTRUCTIONS } from '../../constants';
import { Section, StyledH4, StyledLi, StyledOl, StyledP1 } from './Common';

const QuestionNavigation = () => {
  return (
    <Section>
      <StyledH4>Navigating to a question</StyledH4>
      <StyledOl>
        <StyledLi>
          <StyledP1>To answer a question, do the following:</StyledP1>
          <StyledOl>
            {QUESTION_NAV_INSTRUCTIONS.map((info, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <StyledLi $listStyle="lower-alpha" key={index}>
                  <DangerousWithSanitization as={StyledP1} html={info.text} />
                </StyledLi>
              );
            })}
          </StyledOl>
        </StyledLi>
      </StyledOl>
    </Section>
  );
};

export default QuestionNavigation;
